import type { FiatPrice } from "@b2bportal/air-shopping-api";
import type { Product } from "@b2bportal/purchase-api";
import { useCheckoutStateSelector } from "@checkout/context";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  productTotalSelectorByProduct,
  roundToTwoDecimal,
} from "@hsbc/utilities";
import { getWalletCreditPayAmount } from "../state";

interface UseBalanceWithTravelCreditsReturn {
  creditPayAmount: number;
  remaingCashBalance: number;
  remainFiatPriceToPay: FiatPrice;
  remainingBalanceFormatted: string;
}

export const useBalanceWithTravelCredits = (
  product?: Product
): UseBalanceWithTravelCreditsReturn => {
  const { formatFiatCurrency } = useI18nContext();

  const { fiat: totalProductPrice } = useCheckoutStateSelector(
    productTotalSelectorByProduct(product)
  );
  const walletCredit = useCheckoutStateSelector(getWalletCreditPayAmount);

  const { value: creditPayAmount } = walletCredit;
  const remaingCashBalance = roundToTwoDecimal(
    totalProductPrice.value - creditPayAmount
  );
  const remainFiatPriceToPay = {
    ...totalProductPrice,
    value: remaingCashBalance,
  };

  const remainingBalanceFormatted = formatFiatCurrency(remainFiatPriceToPay);

  return {
    creditPayAmount,
    remainFiatPriceToPay,
    remainingBalanceFormatted,
    remaingCashBalance,
  };
};
